module.exports = __webpack_public_path__ + "64ec6919d71c957e6cab85b0f0e4deea.png";